import { Col, Row } from "antd";
import React from "react";
import { withTranslation } from "react-i18next";
import "./style.scss";
import AuthSignIn from "../../components/authSignIn";
import AuthSignUp from "../../components/authSignUp";
import AuthConfirmOTP from "../../components/authConfirmOTP";
import { ROUTER_PATH } from "../../common/constant";
import { localizeRouteKey } from "../../shared/helpers";
import AuthForgotPassword from "../../components/authForgotPassword";

const Authentication = (props: any) => {
  const url = location.pathname;

  return (
    <div className="container">
      <Row className="kd-card-sign-in-form" justify="center" align="middle">
        <Col flex={1} className="authen-wrap">
          {url === localizeRouteKey(ROUTER_PATH.SIGN_IN) && (
            <AuthSignIn {...props} />
          )}
          {url === localizeRouteKey(ROUTER_PATH.SIGN_UP) && (
            <AuthSignUp {...props} />
          )}
          {url === localizeRouteKey(ROUTER_PATH.FORGOT_PASSWORD) && (
            <AuthForgotPassword {...props} />
          )}
          {url === localizeRouteKey(ROUTER_PATH.CONFIRM_OTP) && (
            <AuthConfirmOTP {...props} />
          )}
        </Col>
      </Row>
    </div>
  );
};

export default withTranslation()(Authentication);
